import { API_URL, API_URL_PHOTO } from "../HelperAxios/const";

/**
 * Build a full asset URL (profile pics, chat attachments, uploads, etc.).
 * Uses REACT_APP_BASE_URL_ASSETS (API_URL_PHOTO), same as Header profile images.
 *
 * Handles:
 * - absolute URLs → returned as-is
 * - `/public/filename.jpg` → strips `/public/` because API_URL_PHOTO includes it
 * - `filename.jpg` → appended to API_URL_PHOTO
 */
export const buildFileUrl = (fileValue) => {
  if (!fileValue) return "";

  if (/^https?:\/\//i.test(fileValue)) {
    return fileValue;
  }

  const base = API_URL_PHOTO || API_URL || "";
  if (!base) {
    return fileValue.startsWith("/") ? fileValue : `/${fileValue}`;
  }

  let path = String(fileValue);
  if (path.startsWith("/public/")) {
    path = path.substring(8);
  } else if (path.startsWith("public/")) {
    path = path.substring(7);
  } else if (path.startsWith("/")) {
    path = path.substring(1);
  }

  return `${base}${path}`;
};
